import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'

import './Barrierefreiheit.css'
import './MBarrierefreiheit.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'


export default function Barrierefreiheit() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={""} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Barrierefreiheit</title>
                <meta property="og:title" content="Barrierefreiheit" />
                <meta property="og:description" content="Hier findest du unsere Erklärung zur Barrierefreiheit" />
                <meta name="description" content="Hier findest du unsere Erklärung zur Barrierefreiheit" />
            </Helmet>
            <section className='sec_next' id='sec_next--barrierefreiheit'>
                <div className='sec_next_cont' id="sec_next--barrierefreiheit--cont" style={{ wordBreak: "break-word", textAlign: "justify" }}>
                    <br /><br />
                    <div className='backbtn'><a href='/rechtliches'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>

                    <h2>Erklärung zur Barrierefreiheit</h2>
                    <h3>1. Gültigkeit</h3>
                    <p>Die ToNetwork UG (haftungsbeschränkt) ist bemüht, ihre Website <a href="https://tonetwork.de">https://tonetwork.de</a> barrierefrei zugänglich zu machen. Grundlage hierfür ist das Barrierefreiheitsstärkungsgesetz (BFSG) in Verbindung mit der Barrierefreiheitsverordnung (BFV).<br />
                        Diese Erklärung zur Barrierefreiheit gilt für die Website: <a href="https://tonetwork.de">https://tonetwork.de</a></p>

                    <h3>2. Stand der Vereinbarkeit mit den Anforderungen</h3>
                    <p>Diese Website ist teilweise vereinbar mit den Anforderungen der EN 301 549 V3.2.1 (2021-03) sowie der Web Content Accessibility Guidelines (WCAG) 2.1 auf Konformitätsstufe AA.</p>
                    <p>Zur Verbesserung der Barrierefreiheit nutzen wir das <a href='https://accessibility-widget.pages.dev/' target='_blank'>Accessibility Widget Sienna</a>, das über das Icon unten Links aufgerufen werden kann.</p>
                    <p>Die Bewertung der Barrierefreiheit beruht auf einer Selbstbewertung vom 12. Juni 2025.</p>

                    <h3>3. Nicht barrierefreie Inhalte</h3>
                    <p>Trotz unserer Bemühungen sind folgende Inhalte derzeit nicht vollständig barrierefrei:</p>
                    <ul>
                        <li>Einzelne <strong>Bilder und Icons</strong> verfügen noch nicht über ausreichende Alternativtexte. Es handelt sich dabei i.d.R. um rein gestalterische Grafiken ohne relevanten Inhalt.</li>
                        <li><strong>PDF-Dokumente</strong>, sofern vorhanden, sind nicht durchgehend barrierefrei strukturiert.</li>
                        <li><strong>Videos</strong> auf der Website enthalten aktuell teilweise keine Untertitel oder Audiobeschreibungen.</li>
                        <li><strong>Lesbarkeit der Texte </strong> ist teilweise durch schwachen Kontrast, bedingt durch die Farbgebung, eingeschränkt. Als Gegenmaßnahme kann das Sienna Accessibility Widget (Icon unten links) genutzt werden.</li>
                    </ul>
                    <p>Wir arbeiten kontinuierlich daran, diese Inhalte barrierefrei bereitzustellen.</p>

                    <h3>4. Freiwillige Umsetzung</h3>
                    <p>Die ToNetwork UG ist gemäß § 3 Abs. 3 BFSG nicht zur Einhaltung der gesetzlichen Barrierefreiheitsanforderungen verpflichtet, da sie weniger als zehn Beschäftigte hat und der Jahresumsatz unter zwei Millionen Euro liegt. Unabhängig davon verfolgen wir das Ziel, unsere Website so barrierefrei wie möglich zu gestalten – als Ausdruck unseres Verständnisses von digitaler Teilhabe und Verantwortung.</p>


                    <h3>5. Feedback und Kontakt</h3>
                    <p>Sollten Ihnen Barrieren auf unserer Website auffallen oder möchten Sie Informationen in barrierefreier Form anfordern, kontaktieren Sie uns bitte:</p>
                    <p>
                        📧 E-Mail: <a href="mailto:info@tonetwork.de?subject=Barrierefreiheit">info@tonetwork.de</a><br />
                        📞 Telefon: <a href='tel:+4983324908872'>+49 8332 4908872</a><br />
                        📬 Adresse: ToNetwork UG (h.), Im Moos 5, 87749 Hawangen
                    </p>

                    <h3>6. Schlichtungsverfahren</h3>
                    <p>Wenn Sie der Ansicht sind, dass Sie durch eine nicht ausreichende barrierefreie Gestaltung unserer Website benachteiligt sind, können Sie sich an die Schlichtungsstelle BGG wenden:</p>
                    <p>
                        <strong>Schlichtungsstelle BGG</strong><br />
                        bei der Beauftragten der Bundesregierung für die Belange von Menschen mit Behinderungen<br />
                        Mauerstraße 53, 10117 Berlin<br />
                        📧 E-Mail: <a href="mailto:info@schlichtungsstelle-bgg.de">info@schlichtungsstelle-bgg.de</a><br />
                        🌐 <a href="https://www.schlichtungsstelle-bgg.de" target="_blank">www.schlichtungsstelle-bgg.de</a>
                    </p>

                    <h3>7. Stand dieser Erklärung</h3>
                    <p>Diese Erklärung wurde am 12.06.2025 erstellt. Letzte Überprüfung siehe oben.</p>

                </div>
            </section >

            <MainFooter />
        </div >
    )
}